import type { CMSMenu } from './cms-menu';

export interface CMSLayout {
  main: CMSMenu | null;
  footer: CMSMenu | null;
  legal: CMSMenu | null;
}

export function createEmptyLayout(): CMSLayout {
  return {
    main: null,
    footer: null,
    legal: null
  };
}
